'use client';

import { useRouter } from 'next/navigation';
import { IconArrowLeft } from '@tabler/icons-react';
import { ActionIcon } from '@mantine/core';

interface IBackButtonProps {
  onClick?: () => void;
}

export function BackButton({ onClick }: IBackButtonProps) {
  const router = useRouter();

  const handleOnClick = () => {
    if (onClick) {
      onClick();
      return;
    }

    if (history.length > 1) {
      router.back();
    }
    router.push('/');
  };

  return (
    <ActionIcon variant="subtle" color="gray" size="lg" onClick={handleOnClick}>
      <IconArrowLeft size={22} stroke={1.5} color="gray" />
    </ActionIcon>
  );
}
